import ReactDOM from "react-dom";
import Backdrop from "./Backdrop";
import React from "react";

const Modal = (props: {
  onClose: () => void;
  children?: React.ReactNode;
  style?: any;
}) => {
  return (
    <>
      {ReactDOM.createPortal(
        <Backdrop style={props.style} onClose={props.onClose} />,
        document.getElementById("backdrop-root") as HTMLElement
      )}
      {ReactDOM.createPortal(
        props.children,
        document.getElementById("content-overlay-root") as HTMLElement
      )}
    </>
  );
};

export default Modal;
